/* eslint-disable */
import React from 'react';
import { string } from 'prop-types';
import { IconPropTypes } from 'ggApp/types/propTypes';

const Whatsapp = ({ className, size, color }) => (
    <svg
        width={size}
        height={size}
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.78511 7.38041C8.23033 6.94509 9.3884 6.77518 9.66816 7.46374C9.73837 7.63654 9.8436 7.90419 9.95185 8.17952C10.1372 8.65107 10.3315 9.14519 10.3739 9.2241C10.5689 9.62292 10.1121 10.0379 9.80138 10.3202C9.77017 10.3486 9.74043 10.3756 9.71298 10.4012C9.57854 10.5053 9.44411 10.6303 9.57854 10.8699C10.3842 12.1953 11.4528 13.0354 12.8722 13.7552C13.1186 13.8802 13.2643 13.8594 13.4211 13.7135C13.506 13.629 13.5947 13.5173 13.6887 13.3989C13.9937 13.0149 14.3545 12.5607 14.8214 12.7344C15.0455 12.8177 16.2554 13.4219 16.5019 13.5469C17.1562 13.8787 17.0723 14.2871 16.7819 14.9427C16.5467 15.4843 15.5048 15.9739 15.0455 15.9947C13.0858 16.0836 11.0885 15.0383 9.71298 13.7636C8.54415 12.6805 6.93785 10.8308 7.0019 9.19286C7.02043 8.71905 7.29144 7.86311 7.78511 7.38041Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9999 2C6.53169 2 1.99992 6.20021 1.99992 11.5C1.99992 13.2222 2.48297 14.8368 3.32362 16.227L2.0384 20.7253C1.92945 21.1066 2.05612 21.5162 2.36128 21.7695C2.66645 22.0228 3.09243 22.0718 3.44713 21.8944L7.38038 19.9278C8.76463 20.6137 10.3369 21 11.9999 21C17.4681 21 21.9999 16.7998 21.9999 11.5C21.9999 6.20021 17.4681 2 11.9999 2ZM3.99992 11.5C3.99992 7.41095 7.52702 4 11.9999 4C16.4728 4 19.9999 7.41095 19.9999 11.5C19.9999 15.5891 16.4728 19 11.9999 19C10.4905 19 9.08374 18.6088 7.88412 17.9324C7.59464 17.7692 7.24299 17.7604 6.94574 17.9091L4.58595 19.089L5.37048 16.3431C5.4517 16.0588 5.40297 15.7532 5.23738 15.5083C4.4517 14.3462 3.99992 12.9724 3.99992 11.5Z"
            fill={color}
        />
    </svg>
);

Whatsapp.propTypes = {
    ...IconPropTypes,
};

Whatsapp.defaultProps = {
    className: '',
    color: '#333333',
    size: '24px',
};

export default Whatsapp;
